import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
    },
    {
      path: '/',
      component: () => import('../components/AppLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: '', name: 'home', component: () => import('../views/HomeView.vue') },
        { path: 'apis', name: 'api-list', component: () => import('../views/ApiListView.vue') },
        { path: 'apis/new', name: 'api-new', component: () => import('../views/ApiEditView.vue') },
        { path: 'apis/:id/edit', name: 'api-edit', component: () => import('../views/ApiEditView.vue') },
        { path: 'functions', name: 'function-list', component: () => import('../views/FunctionListView.vue') },
        { path: 'functions/new', name: 'function-new', component: () => import('../views/FunctionEditView.vue') },
        { path: 'functions/:id/edit', name: 'function-edit', component: () => import('../views/FunctionEditView.vue') },
        { path: 'todos', name: 'todos', component: () => import('../views/TodoPanelView.vue') },
        { path: 'groups', name: 'groups', component: () => import('../views/GroupTreeView.vue') },
        { path: 'reviews', name: 'reviews', component: () => import('../views/ReviewsView.vue') },
        { path: 'schedules', name: 'schedules', component: () => import('../views/SchedulesView.vue') },
        { path: 'help', name: 'help', component: () => import('../views/HelpView.vue') },
        { path: 'datasources', name: 'datasources', component: () => import('../views/DatasourceView.vue') },
        { path: 'audit', name: 'audit', component: () => import('../views/AuditView.vue') },
        { path: 'analytics', name: 'analytics', component: () => import('../views/AnalyticsView.vue') },
        { path: 'members', name: 'members', component: () => import('../views/MembersView.vue') },
        { path: 'settings', name: 'settings', component: () => import('../views/SettingsView.vue') },
        { path: 'subdomains', name: 'subdomains', component: () => import('../views/SubdomainsView.vue') },
      ],
    },
  ],
})

// 2026-05-29: token resolution order, most-trusted first.
//
// 1. URL hash `#token=...&tenant_id=...` — emitted by console's
//    "Open editor →" link (subdomains.vue::editorHref). This is the
//    primary cross-subdomain SSO carrier; Chrome's heuristic cookie
//    partitioning makes a `.mustapi.com` cookie set via cross-origin
//    XHR invisible to sibling subdomains, so a URL-fragment handoff
//    is the only thing that survives.
// 2. localStorage `must_token` / `mustapi_token` — per-origin cache,
//    set once the hash has been consumed and persisted (see
//    `stores/auth.ts::mirrorOnBoot`).
// 3. `must_session` cookie — last-resort fallback. Works for the
//    original login origin but rarely cross-subdomain on modern Chrome.
function readToken(): string | null {
  // 1. Hash. Don't consume here — `stores/auth.ts::mirrorOnBoot` is the
  //    canonical consumer; we only peek for the gate decision.
  const hash = (typeof window !== 'undefined' && window.location.hash) || ''
  if (hash.includes('token=')) {
    const params = new URLSearchParams(hash.replace(/^#/, ''))
    const t = params.get('token')
    if (t) return t
  }
  // 2. localStorage.
  const ls = localStorage.getItem('must_token') || localStorage.getItem('mustapi_token')
  if (ls) return ls
  // 3. Cookie.
  const m = document.cookie.match(/(?:^|;\s*)must_session=([^;]+)/)
  return m ? decodeURIComponent(m[1]) : null
}

router.beforeEach((to) => {
  const token = readToken()
  if (to.meta.requiresAuth && !token) {
    return { name: 'login' }
  }
  if (to.name === 'login' && token) {
    return { name: 'home' }
  }
})

export default router
